import { useEffect } from "react";
import "./MainInfo.css";
import { Link } from "react-router-dom";

const MainInfo = () => {

  useEffect(() => {
    const header = document.querySelector("header, #header");
    if (header) {
      document.documentElement.style.setProperty(
        "--header-h-mobile",
        `${header.offsetHeight}px`
      );
    }
  }, []);

  return (
    <section id="main" className="d-flex align-items-center">
      <div className="container">
        <div>
          <h1>
            Profesjonalna diagnostyka online
            <br />
            Zadbaj o zdrowie psychiczne bez czekania
          </h1>
          <h2>
          Synavie to połączenie technologii i najwyższych standardów psychologicznych.
          Oferujemy precyzyjną diagnozę bez kolejek, bez stresu i bez wychodzenia z domu.
          </h2>
        </div>
        <div className="d-flex justify-content-start gap-2">
          <Link to={"/umow-wizyte"} className="btn-get-started scrollto">
            Umów wizytę
          </Link>
          <Link to={"/twoje-wizyty"} className="btn-get-started scrollto check-appointments">
            Sprawdź swoje wizyty
          </Link>
        </div>
      </div>
    </section>
  );
};
export default MainInfo;
